import { useIntl } from "react-intl";

import { DrawerTopBar } from "@/components/Drawer/DrawerTopBar";
import { SwipeableDrawer } from "@/components/Drawer/SwipeableDrawer";
import type { FlightsSortValue } from "@/features/flights/types/types";

import FlightsSort from "./flight-filters/FlightsSort";

type Props = {
  open: boolean;
  value: FlightsSortValue;
  onSubmit: (newValue: FlightsSortValue) => void;
  onClose: () => void;
};

export const FlightsSortDrawer = ({
  open,
  value,
  onSubmit,
  onClose,
}: Props) => {
  const intl = useIntl();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <DrawerTopBar
        onCloseClick={onClose}
        title={intl.formatMessage({
          id: "flights.sort",
          defaultMessage: "Sort",
        })}
      />
      <FlightsSort value={value} onChange={onSubmit} />
    </SwipeableDrawer>
  );
};
